<template>
  <div class="p-home">
    <!-- banner -->
    <banner
      :navigationSelected365="navigationSelected365"
      @homeCallback="homeCallbackFn"
    />
    <div class="p-virtual-dom"></div>
    <div class="p-home-navigation">
      <kd-row>
        <kd-segmented-controller :active="activeText">
          <kd-segmented-item 
            v-for="(item, index) in navigationTab" 
            :key="item + index" 
            :index="index"
            :name="item" 
            :text="item" 
            @change="changeItemFn(index)">
          </kd-segmented-item>
        </kd-segmented-controller>
      </kd-row>
    </div>

    <!-- 块 区域 -->
    <div class="p-home-block">
      <!-- WPS365教育版 -->
      <template v-if="navigationSelected365">
        <!-- 办公体验 -->
        <works />
        <!-- 智慧校园 -->
        <edu @homeCallback="homeCallbackFn" />
        <!-- 套餐价格 -->
        <Price @homeCallback="homeCallbackFn" />
        <!-- 数据安全 -->
        <secure />
      </template>

      <!-- WPS智慧教育平台 -->
      <template v-else>
        <!-- 解决方案 -->
        <Solve @homeCallback="homeCallbackFn" />
        <!-- 功能场景服务 -->
        <Ability @homeCallback="homeCallbackFn" />
        <!-- AI助力教与学 -->
        <Ai @homeCallback="homeCallbackFn" />
        <!-- 专属服务 -->
        <Service @homeCallback="homeCallbackFn" />
      </template>

      <!-- 客户案例 -->
      <custom @homeCallback="homeCallbackFn" />
    </div>

    <!-- footer -->
    <FooterBanner
      :navigationSelected365="navigationSelected365"
      @homeCallback="homeCallbackFn"
    />
  </div>
</template>

<script>
import Banner from './components/Banner.vue';
import FooterBanner from './components/FooterBanner.vue';

import Works from './components/0/Work.vue';
import Edu from './components/0/Edu.vue';
import Price from './components/0/Price.vue';
import Secure from './components/0/Secure.vue';
import Custom from './components/0/Custom.vue';

import Ability from './components/1/Ability.vue';
import Service from './components/1/Service.vue';
import Ai from './components/1/Ai.vue';
import Solve from './components/1/Solve.vue';

import infoCollect from '@/common/infoCollect';
import { getFromPage } from '@/common/utils/index';

export default {
  name: 'HomeView',
  components: {
    Banner,
    Works,
    Secure,
    Edu,
    Price,
    Custom,
    FooterBanner,
    Ability,
    Service,
    Ai,
    Solve,
  },
  data() {
    return {
      isPc: true,
      navigationSelected365: true,
      navigationTab: ['WPS 365 教育版', 'WPS智慧教育平台'],
      activeText: 'WPS 365 教育版',
    };
  },
  methods: {
    changeItemFn(index) {
      this.navigationSelected365 = index === 0;
      infoCollect.dwCollectData(
        'button_click',
        index === '0' ? 'edu_365tab' : 'edu_smart_tab',
        'PC',
        { page_name: 'edu_web_home_page', from_item: getFromPage() },
      );
      document
        .getElementById('app')
        .scrollIntoView({ block: 'start', behavior: 'smooth' });
    },
    toPrice() {
      infoCollect.dwCollectData(
        'button_click',
        'look_complete_introduction',
        'PC',
        { page_name: 'edu_web_home_page', from_item: getFromPage() },
      );
      this.$router.push('/price?fromPage=edu_web_home_page');
    },
    homeCallbackFn(param) {
      if (param?.dwClickName) {
        // 上报点击埋点
        infoCollect.dwCollectData('button_click', param?.dwClickName, 'PC', {
          page_name: 'edu_web_home_page',
          from_item: getFromPage(),
        });
      }
      if (param?.banOpen) {
        return;
      }
      window.open('https://f.kdocs.cn/g/9bxKq8bk/', '_blank');
    },
  },
  mounted() {
    infoCollect.dwCollectData('page_show', 'edu_web_home_page', 'PC');
  },
};
</script>
<style lang="scss" scoped>
.p-home {
  min-height: 100vh;
  position: relative;
  .p-virtual-dom {
    position: absolute;
    top: 588px;
    height: 10px;
    width: 10px;
    z-index: 99;
    left: 50%;
    visibility: hidden;
  }
  .p-home-block {
    display: inline-block;
    margin: 0 auto;
    width: 100%;
    > div {
      &:first-child {
        margin-top: 112px;
      }
      margin: 0 auto 100px auto;
      width: 100%;
      max-width: 1200px;
    }
  }
  .p-home-block :deep(.p-block) {
    &.price {
      margin-top: 72px;
    }
    .p-block-title {
      text-align: center;
      color: var(--kd-color-text-primary, rgb(13 13 13 / 90%));
      p:last-child {
        margin-bottom: 0;
      }
      .main {
        font-weight: 600;
        font-size: 36px;
        line-height: 58px;
        margin-bottom: 4px;
      }
      .sub {
        margin-bottom: 12px;
        font-size: 18px;
        line-height: 29px;
      }
    }
    ul.price {
      height: 29px;
      li {
        display: inline-block;
        margin-top: 8px;
        margin-right: 32px;
        line-height: 20px;
        font-size: 18px;
        vertical-align: middle;
      }
    }
    @include responsiveV2($width-s) {
      .main {
        font-size: 32px !important;
        line-height: 51px !important;
      }
      .sub {
        font-size: 16px !important;
        line-height: 26px !important;
      }
    }
  }
  :deep(.p-block-more) {
    margin: 40px auto 0px auto;
    text-align: center;
    label.kd-icon-box {
      cursor: pointer;
    }
  }
}

.p-home-price {
  background-size: cover;
  text-align: center;
  overflow-x: hidden;
  padding: 83px 48px 74px 48px;
  &-title {
    font-weight: 700;
    font-size: 36px;
    line-height: 64px;
    color: rgba(13, 13, 13, 0.9);
  }

  &-desc {
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 30px;
    color: rgba(13, 13, 13, 0.66);
  }

  &-detail {
    font-weight: 400;
    font-size: 16px;
    line-height: 21px;
    color: #2953c8;
    cursor: pointer;
    margin-bottom: 60px;
  }
}

.p-home-navigation {
  text-align: center;
  margin-top: -110px;
  position: sticky;
  z-index: 99;
  top: 80px;
  transition:
    top 0.3s,
    transform 0.3s;
  height: 58px;
  border-radius: 51px;
  .kdv-segmented-controller {
    border-radius: 999px;
    width: 640px;
    box-sizing: border-box;
    margin: 0 auto;
    box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.08);
    background: #fff;
    padding: 4px;
    overflow: hidden;
    .kdv-segmented-item {
      flex: 1;
      padding: 0;
      :deep(.kdv-button) {
        width: 316px;
        height: 50px;
        line-height: 50px !important;
        font-size: 18px;
        color: var(--kd-color-text-secondary, rgba(13, 13, 13, 0.66));
        font-weight: 400;
        text-align: center;
        background: #fff;
        margin: 0px;
      }
      &.is-active {
        :deep(.kdv-button) {
          font-weight: 600;
          color: var(--kd-color-text-primary, rgb(13 13 13 / 90%));
          background: rgba(211, 211, 211, 0.3);
          border-radius: 999px;
        }
      }
    }
  }
}
</style>
